const dev = process.env.NODE_ENV !== 'production'

//export const url = dev ? 'https://inscreen.it' : 'https://inscreen.it'
export const url = dev ? 'https://inscreen.ddev.site' : 'https://inscreen.it'
